import React from "react";
import { useTranslation } from "react-i18next";
import { Heart, ShieldCheck, Sparkles, Users } from "lucide-react";
import { API } from "../context/AuthContext";

const IMG = (p) => `${API}/static/illustrations/${p}`;

export default function About() {
  const { t } = useTranslation();
  return (
    <div data-testid="about-page">
      <section className="relative overflow-hidden py-20">
        <span className="geo-shape bg-[#16A34A]/20 h-72 w-72 -top-20 right-1/4 drift-slow" aria-hidden />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <span className="pill"><Heart className="h-3.5 w-3.5" /> {t("about.pill")}</span>
            <h1 className="mt-4 font-display text-5xl sm:text-6xl font-black text-[#0A2518] leading-tight tracking-tight">
              {t("about.title1")} <em className="text-[#16A34A] not-italic">{t("about.titleEm")}</em> {t("about.title2")}
            </h1>
            <p className="mt-8 text-lg text-[#4B5563] leading-relaxed">{t("about.p1")}</p>
            <p className="mt-6 text-lg text-[#4B5563] leading-relaxed">{t("about.p2")}</p>
          </div>
          <div className="relative">
            <div className="rounded-3xl overflow-hidden border border-[#E5EBE7] shadow-xl">
              <img src={IMG("about_hero.png")} alt="" className="w-full h-[560px] object-cover" />
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-[#F3F7F5]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white rounded-2xl border border-[#E5EBE7] p-8">
              <ShieldCheck className="h-8 w-8 text-[#16A34A] mb-4" />
              <h3 className="font-display text-2xl font-semibold text-[#0A2518] mb-2">{t("about.value1Title")}</h3>
              <p className="text-[#4B5563]">{t("about.value1Text")}</p>
            </div>
            <div className="bg-white rounded-2xl border border-[#E5EBE7] p-8">
              <Sparkles className="h-8 w-8 text-[#16A34A] mb-4" />
              <h3 className="font-display text-2xl font-semibold text-[#0A2518] mb-2">{t("about.value2Title")}</h3>
              <p className="text-[#4B5563]">{t("about.value2Text")}</p>
            </div>
            <div className="bg-white rounded-2xl border border-[#E5EBE7] p-8">
              <Users className="h-8 w-8 text-[#16A34A] mb-4" />
              <h3 className="font-display text-2xl font-semibold text-[#0A2518] mb-2">{t("about.value3Title")}</h3>
              <p className="text-[#4B5563]">{t("about.value3Text")}</p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-display text-4xl font-bold text-[#0A2518]">{t("about.contactTitle")}</h2>
          <p className="mt-4 text-[#4B5563]">{t("about.contactText")}</p>
        </div>
      </section>
    </div>
  );
}
